import React from 'react';
import { ApSimpleDropdown } from '@alixpartners/ui-components';

import { Wrapper, Label } from './styles';
import { EXPORT_OPTIONS } from 'Pmi/constants';

export const ChartOptions = props => {
	const { onPngExportClick, label, exportId, onExportData } = props;

	const handleExportSelect = selectedItem => {
		if (selectedItem.value === 'png') {
			onPngExportClick && onPngExportClick(exportId);
		} else if (selectedItem.value === 'xlsx') {
			onExportData && onExportData();
		}
	};

	return (
		<Wrapper>
			<Label>{label}</Label>
			<ApSimpleDropdown
				options={EXPORT_OPTIONS}
				label="Export"
				onChange={handleExportSelect}
				iconName="outline_save_alt"
			/>
		</Wrapper>
	);
};

export default ChartOptions;
